"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var autoBind = require('../autoBind');

var ReactClass = function (_React$Component) {
  _inherits(ReactClass, _React$Component);

  function ReactClass(props) {
    _classCallCheck(this, ReactClass);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReactClass).call(this, props));

    autoBind(_this);
    return _this;
  }

  return ReactClass;
}(React.Component);

exports.default = ReactClass;
exports.autoBind = autoBind;
exports.Component = ReactClass;


//////////////////
// WEBPACK FOOTER
// ../~/react-class/lib/index.js
// module id = 2688
// module chunks = 2